module.exports = __webpack_public_path__ + "img/2.6e097d6c.png";